import React from "react";
import HasNotifications from "../components/HasNotifications";

/* -------------------------------------------------------------------------- */
/*                              INDIVIDUAL PATHS                              */
/* -------------------------------------------------------------------------- */

export const homePath = {
    url: "/",
    alt: "Noun Project home"
};

export const eduPath = "/for-edu/";

export const eduApplyPath = "/for-edu/apply/";

export const teamPath = "/team/";

export const proTeamSignupPath = "/accounts/signup/team/";

export const apiGetStartedPath = "/developers/apps/";

export const contactCustomerSupportLink = "mailto:info@thenounproject.com";

export const customerSupportLink = {
    name: "Customer Support",
    href: "https://thenounproject.zendesk.com/",
    external: true
};

export const PHOTO_PATH = "/photos/";

export const photosLandingPath = "/photos/";

export const lingoMarketingPagePath = "/lingo/";

export const iconsSearchPath = "/search/";

export const iconsCollectionSearchPath = "/search/collection/";

export const accountUpgradePath = "/accounts/pricing/";

export const apiMarketingPagePath = "/developers/";

export const appsAndPluginsPath = "/apps/";

export const proSignupPath = "/accounts/signup/pro/";

export const aboutPath = "/about/";

// Photos Related Routes
export const PRICING = "/pricing/";
export const SEARCH = `/search/photos/`;
// :purchaseType should be lowercase
export const CHECKOUT = "/checkout/photo/:purchaseType/:photoId";
export const PHOTO_DETAIL = "/photo/:photoSlugWithId/";
export const BROWSE_BY_TAG = "/browse/term/photos/:tag/";
// BROWSE_BY_SHOOT_ID :shootInfo consist of {shoot-title}-{shoot-id}
export const BROWSE_BY_SHOOT_ID = "/browse/photo-shoot/:shootInfo/";
export const BROWSE_BY_CREATOR_USERNAME = "/browse/creator/:username/photos/";
export const BROWSE_SIMILAR_BY_PHOTO_ID = "/browse/similar/photos/:photoId/";
// BROWSE_BY_CAMPAIGN :shootInfo consist of {campaign-title}-{campaign-id}
export const BROWSE_BY_CAMPAIGN = "/browse/campaign/:campaignDetail/";

// Icons (2020) Related Routes
export const ICON_DETAIL_PAGE = "/private/icon/";

/* -------------------------------------------------------------------------- */
/*                                    MENUS                                   */
/* -------------------------------------------------------------------------- */

export const authLinks = {
    login: {
        href: "/accounts/login/",
        text: "Login"
    },
    signup: {
        href: "/accounts/signup/",
        text: "Join"
    },
    logout: {
        href: "/accounts/logout/",
        text: "Log Out"
    }
};

export const adminMenu = [
    {
        name: "Moderation",
        href: "/fort/modparty/"
    },
    {
        name: "Members",
        href: "/fort/members/"
    },
    {
        name: "Icons",
        href: "/fort/icon/"
    },
    {
        name: "Collections",
        href: "/fort/collections/"
    }
];

export const myAccountMenu = [
    {
        name: "Settings",
        href: ({ username }) => `/${username}/settings/basics/`
    },
    {
        name: "Billing Info",
        href: ({ username }) => `/${username}/settings/billing/`
    },
    {
        name: "Invoices",
        href: ({ username }) => `/${username}/settings/invoices/`
    },
    {
        name: "Prepaid Balance",
        href: ({ username }) => `/${username}/settings/prepaid-balance/`
    }
];

export const myStuffMenu = [
    {
        name: "Profile",
        href: "/dashboard/"
    },
    {
        name: "Download History",
        href: ({ username }) => `/${username}/settings/icon-history/`
    },
    {
        name: "Saved Icons",
        href: ({ username }) => `/${username}/kits/`
    }
];

export const myStuffApiMenu = [
    {
        name: "Manage API Apps",
        href: "/developers/apps/"
    },
    {
        name: "API Documentation",
        href: "http://api.thenounproject.com/",
        external: true
    }
];

const hasNotificationsText = ({ hasNotifications }) => (
    <HasNotifications hasNotifications={hasNotifications} />
);

export const creatorMenu = [
    {
        name: "Creator Dashboard",
        href: "/dashboard/"
    },
    {
        name: ({ hasNotifications }) =>
            hasNotificationsText({ hasNotifications }),
        href: ({ username }) => `/${username}/activity/`
    },
    {
        name: "Collections",
        href: ({ username }) => `/${username}/collections/`
    },
    {
        name: "Royalties",
        href: ({ username }) => `/${username}/royalties/`
    },
    {
        name: "Upload",
        href: "/upload/"
    },
    {
        name: "Creator Handbook",
        href: "/handbook/"
    }
];

export const nounProjectMenu = [
    {
        name: "About",
        href: aboutPath
    },
    {
        name: "Blog",
        href: "https://blog.thenounproject.com/",
        external: true
    },
    {
        name: "Jobs",
        href: "https://apply.workable.com/nounproject/",
        external: true
    },
    {
        name: "Iconathons",
        href: "https://blog.thenounproject.com/tagged/iconathon",
        external: true
    },
    {
        name: "Become a Creator",
        href: "/creators/"
    },
    customerSupportLink,
    {
        name: "Legal",
        href: "/legal/"
    }
];

export const productMenu = [
    {
        name: "Icons",
        href: homePath.url
    },
    {
        name: "Photos",
        href: photosLandingPath
    },
    {
        name: "Pricing",
        href: PRICING
    },
    {
        name: "Apps & Plugins",
        href: appsAndPluginsPath
    },
    {
        name: "API",
        href: apiMarketingPagePath
    },
    {
        name: "Lingo",
        href: lingoMarketingPagePath
    }
];

export const socialMedia = [
    {
        name: "Twitter",
        href: "http://www.twitter.com/nounproject"
    },
    {
        name: "Facebook",
        href: "http://www.facebook.com/thenounproject"
    },
    {
        name: "Instagram",
        href: "http://www.instagram.com/nounproject"
    },
    {
        name: "Dribbble",
        href: "http://www.dribbble.com/nounproject"
    },
    {
        name: "Behance",
        href: "http://www.behance.com/noun_project"
    }
];

export const footerMenu = [
    {
        name: "About Us",
        href: "/about/",
        external: false
    },
    {
        name: "Contact Us",
        href: `${contactCustomerSupportLink}?subject=Wanted to get in contact`,
        external: true
    },
    customerSupportLink,
    {
        name: "Jobs",
        href: "/jobs/",
        external: true
    },
    {
        name: "Legal",
        href: "/legal/",
        external: false
    }
];
